import React, { useState } from 'react';
import BuyBack from 'components/BuyBack/BuyBack';
import { IBuyBackConfig, IBuyBackProduct } from 'components/BuyBack/interfaces/buyBackInterfaces';

interface IProps {
    config: IBuyBackConfig;
}

const BuyBackStandaloneWrapper = (props: IProps) => {
    const { config } = props;
    const [currentBuyBackProduct, setCurrentBuyBackProduct] = useState<IBuyBackProduct>();
    return (
        <BuyBack
            setCurrentBuyBackProduct={setCurrentBuyBackProduct}
            config={config}
            currentBuyBackProduct={currentBuyBackProduct}
        />
    );
};

export default BuyBackStandaloneWrapper;
